// 🔥 Em dev (npm start) o CRA usa o "proxy" do package.json pra mandar /api pro backend na 3010.
// Em produção, o build é servido pelo próprio Express do backend, então /api já cai no mesmo
// domínio — nenhuma URL absoluta é necessária em nenhum dos dois casos.
export function getToken() {
  return localStorage.getItem("adminToken");
}

export function setSessao(token, admin) {
  localStorage.setItem("adminToken", token);
  localStorage.setItem("adminNome", admin?.nome || "");
}

export function limparSessao() {
  localStorage.removeItem("adminToken");
  localStorage.removeItem("adminNome");
}

export async function api(caminho, opts = {}) {
  const resp = await fetch(caminho, {
    ...opts,
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + getToken(),
      ...(opts.headers || {}),
    },
  });

  if (resp.status === 401) {
    limparSessao();
    window.location.href = "/auth/sign-in";
    return null;
  }

  return resp.json();
}

export async function apiLogin(email, senha) {
  const resp = await fetch("/api/admin/login", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, senha }),
  });
  return resp.json();
}
